import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=1fd20565&"
import script from "./SectionItem.vue?vue&type=script&lang=js&"
export * from "./SectionItem.vue?vue&type=script&lang=js&"
import style0 from "./SectionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
